import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { fetchWithoutToken } from '../../utils/fetch';
import './Login.css';

const Login = () => {
	const { instance } = useMsal();
	const navigate = useNavigate();
	const [failedAuth, setFailedAuth] = useState(false);

	useEffect(() => {
		instance
			.handleRedirectPromise()
			.then((msalResponse) => {
				if (msalResponse?.account) {
					fetchWithoutToken
						.post('/auth-admin', {
							username: process.env.REACT_APP_AUTH_USERNAME,
							password: process.env.REACT_APP_PASSWORD,
						})
						.then((response) => {
							localStorage.token = response.data.access_token;
							localStorage.name = msalResponse.account.name;
							localStorage.email = msalResponse.account.username;
							navigate('/admin');
						})
						.catch((err) => {
							console.error('Auth‑admin error', err);
							setFailedAuth(true);
							setTimeout(() => setFailedAuth(false), 3000);
						});
				}
			})
			.catch((err) => {
				console.error('Redirect handling error', err);
				setFailedAuth(true);
				setTimeout(() => setFailedAuth(false), 3000);
			});
	}, [instance, navigate]);

	const loginHandler = () => {
		instance.loginRedirect(loginRequest);
	};

	if (failedAuth) {
		return <p className='notAuthenticatedUser'>User not authenticated</p>;
	}

	return (
		<button onClick={loginHandler} className='loginButton'>
			Sign in with Microsoft
		</button>
	);
};

export default Login;
